<div class="container mx-auto text-center">
  <span class="close" role="button" tabindex="0" aria-label="Sluiten" mat-dialog-close><mat-icon aria-hidden="true">close</mat-icon></span>
  <div class="justify-center items-center text-center">
    <img class="mx-auto" src="assets/images/logo-img.svg" alt="BeeFund" />
    <h1 mat-dialog-title>{{ 'Inloggen' | translate }}</h1>
    <p>{{ 'Log in met je BeeFund account' | translate }}</p>
  </div>
  <form [formGroup]="loginForm" (ngSubmit)="login()" autocomplete="on">
    <div class="flex flex-col">
      <div class="flex flex-row md:flex-col mr-2">
        <div class="basis-4/5">
          <mat-form-field appearance="fill" floatLabel="auto">
            <mat-label>{{ 'E-mail' | translate }}</mat-label>
            <input matInput type="email" inputmode="email" spellcheck="false" name="username" [placeholder]="'E-mail'|translate" formControlName="username" id="username" autocomplete="username" required>
            <mat-error>
              <div *ngIf="showValidation && username.invalid && username.errors.required">{{ 'E-mail is verplicht' | translate }}</div>
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="auto">
            <mat-label>{{ 'Wachtwoord' | translate }}</mat-label>
            <input matInput type="password" name="password" [placeholder]="'Wachtwoord'|translate" formControlName="password" id="password" autocomplete="current-password" required>
            <mat-error>
              <div *ngIf="showValidation && password.invalid && password.errors.required">{{ 'Wachtwoord is verplicht' | translate }}</div>
            </mat-error>
          </mat-form-field>
          <!-- <mat-form-field appearance="fill" floatLabel="auto">
            <mat-select [(value)]="language">
              <mat-option value="en">English</mat-option>
              <mat-option value="nl">Dutch</mat-option>
            </mat-select>
          </mat-form-field> -->
        </div>
    </div>
    <div class="flex flex-col justify-center items-center content-center margin-right-10">
      <p><a role="button" tabindex="0" (click)="forgotPassword()" (keydown.enter)="forgotPassword()">{{ 'Wachtwoord vergeten?' | translate }}</a></p>
      <button mat-raised-button type="submit" color="accent">{{'Inloggen'|translate}}</button>
      <p><span>{{ 'Nog niet geregistreerd?' | translate }} </span><a role="button" tabindex="0" (click)="signUp()" (keydown.enter)="signUp()"> {{ 'Registreren' | translate }}</a></p>
    </div>
  </div>
  </form>
</div>